[
  {
    "id": "TG-M7P-L204-001",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "In Tokio is het 8 uur later dan in Nederland. In Nederland is het 21:30. Hoe laat is het in Tokio?",
    "options": ["05:30", "13:30", "23:30", "03:30"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "tijdzones",
    "familyId": "TG-TIJD-TIJDZONE-OPTELLEN-OVER_NACHT",
    "conceptId": "timezone_add_crossing_midnight",
    "variantIndex": 1,
    "explanation": "Tokio is 8 uur later, dus je telt 8 uur op.\n21:30 + 8 uur = 29:30.\n29:30 betekent: 24 uur eraf → 05:30 (volgende dag).",
    "distractorExplanations": {
      "1": "Je hebt 8 uur afgetrokken (alsof Tokio vroeger is). Maar ‘later’ betekent optellen.",
      "2": "Je hebt wel opgeteld maar je bent niet over middernacht gegaan. 21:30 + 8 uur komt niet uit op 23:30; je moet doorrekenen tot voorbij 24:00.",
      "3": "03:30 ontstaat als je 6 uur optelt of per ongeluk 8 uur als 6 uur behandelt. Controleer stap voor stap: 21:30 + 2 = 23:30, +2 = 01:30, +2 = 03:30, +2 = 05:30."
    }
  },
  {
    "id": "TG-M7P-L204-002",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een bus vertrekt om 18:47 en komt aan om 21:05. Hoe lang duurt de rit?",
    "options": ["2 uur 18 min", "2 uur 12 min", "3 uur 18 min", "2 uur 58 min"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "tijdsduur",
    "familyId": "TG-TIJD-DUUR-TUSSEN_TIJDEN-OVER_UUR",
    "conceptId": "elapsed_time_between_times_crossing_hour",
    "variantIndex": 1,
    "explanation": "Reken handig via het hele uur.\n18:47 → 19:00 = 13 min.\n19:00 → 21:00 = 2 uur.\n21:00 → 21:05 = 5 min.\nTotaal: 2 uur en (13 + 5) min = 2 uur 18 min.",
    "distractorExplanations": {
      "1": "Je hebt de minuten verkeerd ‘geleend’. Van 18:47 naar 21:05 kun je niet simpel 05 − 47 doen zonder een uur om te zetten in minuten. Werk via 19:00 en 21:00.",
      "2": "3 uur 18 min zou kloppen als aankomst 22:05 was. Maar aankomst is 21:05.",
      "3": "2 uur 58 min ontstaat vaak door minuten als 47 → 05 te zien als ‘58 minuten’, maar dan vergeet je dat er ook uren tussen zitten. Het verschil is 2 uur en 18 min."
    }
  },
  {
    "id": "TG-M7P-L204-003",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Hoeveel seconden is 3,25 uur?",
    "options": ["11.700", "10.800", "9.750", "3.250"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "omrekenen",
    "familyId": "TG-TIJD-OMREKENEN-DECIMAAL_UUR-NAAR_SECONDES",
    "conceptId": "convert_decimal_hours_to_seconds",
    "variantIndex": 1,
    "explanation": "3,25 uur = 3 uur + 0,25 uur.\n0,25 uur is een kwartier = 15 minuten.\nDus 3 uur 15 min.\nIn seconden: 3 uur = 3 × 3.600 = 10.800.\n15 min = 15 × 60 = 900.\nSamen: 10.800 + 900 = 11.700 seconden.",
    "distractorExplanations": {
      "1": "10.800 seconden is alleen 3 uur. Je mist nog 0,25 uur (15 minuten = 900 seconden).",
      "2": "9.750 ontstaat als je 0,25 uur ziet als 0,25 × 60 = 15 en dan iets vergeet om te zetten naar seconden. Je moet uiteindelijk alles in seconden uitdrukken.",
      "3": "3.250 is alsof je de komma ‘meeneemt’ zonder omrekening. Tijd omrekenen gaat via 60 en 3.600, niet via het getal ‘3,25’ letterlijk."
    }
  },
  {
    "id": "TG-M7P-L204-004",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een jas kost € 120. Je krijgt 30% korting en daarna betaal je nog € 6 verzendkosten. Wat betaal je in totaal?",
    "options": ["€ 90", "€ 84", "€ 78", "€ 96"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld",
    "subSkill": "korting_meerstaps",
    "familyId": "TG-GELD-KORTING-PERCENT-DAN_VASTE_KOSTEN",
    "conceptId": "discount_then_add_fixed_fee",
    "variantIndex": 1,
    "explanation": "30% korting betekent dat je 70% betaalt.\n70% van € 120 = 0,7 × 120 = € 84.\nDaarna komen de verzendkosten erbij: € 84 + € 6 = € 90.",
    "distractorExplanations": {
      "1": "€ 84 is de prijs ná korting, maar je hebt de verzendkosten nog niet erbij geteld.",
      "2": "€ 78 krijg je als je de € 6 verzendkosten óók ‘korting’ geeft of verkeerd aftrekt. Verzendkosten komen juist bovenop het kortingsbedrag.",
      "3": "€ 96 ontstaat als je 20% korting rekent (of 30% verwart). Controleer: 30% van 120 is 36, dus 120 − 36 = 84 en dan +6 = 90."
    }
  },
  {
    "id": "TG-M7P-L204-005",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een pak rijst van 750 g kost € 2,25. Een pak van 1,2 kg kost € 3,36. Welke is goedkoper per kilogram?",
    "options": ["De 1,2 kg is goedkoper", "De 750 g is goedkoper", "Ze zijn even duur per kg", "Niet te bepalen zonder rekenmachine"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld",
    "subSkill": "prijsvergelijk",
    "familyId": "TG-GELD-PRIJS-PER_KILO-VERGELIJKEN",
    "conceptId": "unit_price_compare_per_kg",
    "variantIndex": 1,
    "explanation": "Reken naar prijs per kg.\n750 g = 0,75 kg → € 2,25 ÷ 0,75 = € 3,00 per kg.\n1,2 kg → € 3,36 ÷ 1,2 = € 2,80 per kg.\nDus 1,2 kg is goedkoper per kilogram.",
    "distractorExplanations": {
      "1": "Als je alleen naar de totaalprijs kijkt, lijkt € 2,25 goedkoper. Maar per kilogram is € 3,00 per kg juist duurder dan € 2,80 per kg.",
      "2": "Even duur zou alleen kloppen als beide per kg hetzelfde uitkomen. Hier zie je: 3,00 per kg versus 2,80 per kg.",
      "3": "Je kunt dit prima zonder rekenmachine doen met slimme stappen: 2,25 ÷ 0,75 is hetzelfde als 225 ÷ 75 = 3; en 3,36 ÷ 1,2 kun je doen door beide ×10: 33,6 ÷ 12 = 2,8."
    }
  },
  {
    "id": "TG-M7P-L204-006",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Je hebt € 50 beltegoed. Je belt 18 minuten. Bellen kost € 0,32 per minuut. Hoeveel tegoed heb je over? (afronden op centen)",
    "options": ["€ 44,24", "€ 44,76", "€ 42,24", "€ 45,68"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld",
    "subSkill": "abonnementen",
    "familyId": "TG-GELD-VERBRUIK-TARIEF_PER_MINUUT-AFTREKKEN",
    "conceptId": "usage_cost_subtract_from_balance",
    "variantIndex": 1,
    "explanation": "Kosten = 18 × € 0,32.\n10 × 0,32 = 3,20\n8 × 0,32 = 2,56\nSamen: € 5,76.\nOver: € 50,00 − € 5,76 = € 44,24.",
    "distractorExplanations": {
      "1": "Je hebt waarschijnlijk 18 × 0,32 verkeerd gedaan (bijvoorbeeld 5,24 of 4,? ). Splits het: 10× en 8× werkt bijna altijd netjes.",
      "2": "€ 42,24 zou kloppen als de kosten € 7,76 waren. Dat is te hoog: 18 × 0,32 is onder de 18 × 0,50 (=9) en rond 6; precies 5,76.",
      "3": "€ 45,68 ontstaat vaak als je 18 × 0,32 ziet als 4,32 (verwisseling met ‘18 minuten’ → ‘0,18’). Maar je moet minuten × tarief doen."
    }
  },
  {
    "id": "TG-M7P-L204-007",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een trein vertrekt om 23:18 en komt aan om 01:02. Hoe lang duurt de reis?",
    "options": ["1 uur 44 min", "2 uur 44 min", "1 uur 56 min", "1 uur 16 min"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijd",
    "subSkill": "tijdsduur",
    "familyId": "TG-TIJD-DUUR-OVER_MIDDERNACHT",
    "conceptId": "elapsed_time_across_midnight",
    "variantIndex": 1,
    "explanation": "Reken via middernacht.\n23:18 → 24:00 = 42 min.\n00:00 → 01:02 = 1 uur 2 min.\nSamen: 42 min + 1 uur 2 min = 1 uur 44 min.",
    "distractorExplanations": {
      "1": "2 uur 44 min krijg je als je 23:18 → 01:02 ziet als ‘2 uur’ plus 44, maar er zit maar 1 uur tussen 00:00 en 01:02.",
      "2": "1 uur 56 min ontstaat als je 23:18 → 24:00 verkeerd rekent (dat is 42 min, geen 54).",
      "3": "1 uur 16 min is alsof je 01:02 − 23:18 zonder middernachtcorrectie doet. Bij tijden die over 24:00 gaan moet je splitsen."
    }
  },
  {
    "id": "TG-M7P-L204-008",
    "module": "TijdGeld",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Je spaart elke week € 7,50. Hoeveel heb je na 9 weken gespaard?",
    "options": ["€ 67,50", "€ 57,50", "€ 75,00", "€ 60,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld",
    "subSkill": "spaargeld",
    "familyId": "TG-GELD-HERHAALDE_BETALING-WEKEN",
    "conceptId": "repeated_payment_weeks_total",
    "variantIndex": 1,
    "explanation": "Je spaart 9 keer € 7,50.\n9 × 7,50 = (10 × 7,50) − 7,50 = 75,00 − 7,50 = € 67,50.",
    "distractorExplanations": {
      "1": "€ 57,50 ontstaat vaak als je 7,50 + 50 doet of 9 verwart met 7. Controleer: 9 × 7,50 zit net onder 10 × 7,50 (=75).",
      "2": "€ 75,00 is 10 weken sparen. Maar je spaart 9 weken, dus er moet 1× € 7,50 af: € 67,50.",
      "3": "€ 60,50 is een onlogische uitkomst omdat 9 × 7,50 precies op halve euro’s uitkomt (.50 of .00). Reken met de 10-weken-truc."
    }
  }
]
